module.exports = __webpack_public_path__ + "static/media/white-shirtblack-waistcoat-tie.e9e6da77.jpg";